export const HOME_PAGE = '/';

// ====== account ======
export const ACCOUNT_PROFILE = '/account/profile';
// export const ACCOUNT_DASHBOARD = '/account/dashboard';

export const ACCOUNT_AUDIOLAB = '/account/audiolab';
export const ACCOUNT_AUDIOLAB_CATEGORY_ID = '/account/audiolab/[category]/[id]';

export const ACCOUNT_PURCHASES = '/account/purchases';
export const ACCOUNT_SALES_EARNINGS = '/account/sales-earnings';

export const ACCOUNT_SETTINGS = '/account/settings';
export const ACCOUNT_SETTINGS_SUBSCRIPTION = '/account/settings/subscription';
export const ACCOUNT_STRIPE_ONBOARDING = '/account/stripe-onboarding';

// ====== subscription ======
export const ACCOUNT_UPGRADE = '/account/upgrade';
export const ACCOUNT_UPGRADE_TYPE_PAY_SUBSCRIPTION = '/account/upgrade/[type]/paysubscription';
export const ACCOUNT_UPGRADE_TYPE_ID_SUCCESS_ORDER_ID = '/account/upgrade/[type]/[id]/success/[orderId]'

export const ACCOUNT_UPGRADE_TYPE_ID_PAY_SUBSCRIPTION = `/account/upgrade/[type]/[id]/paysubscription`


// ====== subscription ======

// unused
export const ACCOUNT_UPGRADE_TYPE_PAY_SUBSCRIPTION_BILLING_INFO = '/account/upgrade/[type]/paysubscription/billing-info';
export const ACCOUNT_UPGRADE_TYPE_PAY_SUBSCRIPTION_PAYMENT_METHOD = '/account/upgrade/[type]/paysubscription/payment-method';
export const ACCOUNT_UPGRADE_TYPE_PAY_SUBSCRIPTION_SUMMARY = '/account/upgrade/[type]/paysubscription/summary';
// ====== account ======

// ====== auth ======
export const AUTH_FORGOT_PASSWORD = '/auth/forgot-password';
export const AUTH_LOGIN = '/auth/login';
export const AUTH_LOGOUT = '/auth/logout';
export const AUTH_RECOVER_PASSWORD = '/auth/recover-password';
export const AUTH_SIGN_UP = '/auth/sign-up';
export const AUTH_SIGN_UP_ERROR = '/auth/signup-error';
export const AUTH_VERIFY_EMAIL = '/auth/verify-email';
// ====== auth ======

// ====== cart ======
export const CART = '/cart';
export const CART_PAY_CART = '/cart/paycart';
export const CART_SUCCESS_ID = '/cart/success/[id]';
// ====== cart ======

// ====== creators ======
export const CREATORS = '/creators';
export const CREATORS_SLUG_ID = '/creators/[slug]/[id]';
// ====== creators ======

// ====== favorites ======
export const FAVOURITES = '/favourites'
export const FAVOURITES_ID = '/favourites/[id]'
// ====== favorites ======

// ====== lyred ======
export const LYRED_CATEGORY_ID = '/lyred/[category]/[id]';
// ====== lyred ======

// ====== marketplace ======
export const MARKETPLACE = '/marketplace';
// ====== marketplace ======

// ====== VIEW BEATS/SONGS ======
export const VIEW_CATEGORY = '/[category]';
export const VIEW_CATEGORY_SLUG_ID = '/[category]/[slug]/[id]';
// ====== VIEW BEATS/SONGS ======

// ====== Error ======
export const ERROR_404 = '/404'
export const ERROR_500 = '/500'
export const API_DOWN = '/api-down'
// ====== Error ======

// ====== legal ======
export const DMCA_POLICY = '/dmca';
export const PRIVACY_POLICY = '/privacy';
export const TERMS_OF_USE = '/terms';
// ====== legal ======







